import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { StaffBenefitsService } from "lib-klab-sdks";
import { StaffBenefitsPort } from "../../../app/ports/employment/staff-benefits.port";
import {
  Benefit,
  BenefitCategory,
  BenefitRequest,
  BenefitType,
} from "../../../domain/models/employment/benefit.model";
import {
  mapBenefit,
  mapBenefitCategory,
  mapBenefitRequest,
} from "../../mappers/employment/benefit.mapper";

@Injectable({ providedIn: "root" })
export class StaffBenefitsPortAdapter implements StaffBenefitsPort {
  constructor(private readonly api: StaffBenefitsService) { }

  listCategories(active = true): Observable<BenefitCategory[]> {
    return this.api.listCategories(active).pipe(
      map((items) => items.map(mapBenefitCategory)),
    );
  }

  list(filters?: {
    companyId?: number;
    type?: BenefitType;
    active?: boolean;
  }): Observable<Benefit[]> {
    return this.api.list(filters).pipe(map((response) => response.map(mapBenefit)));
  }

  getById(benefitId: number): Observable<Benefit> {
    return this.api.getById(benefitId).pipe(map(mapBenefit));
  }

  create(request: BenefitRequest): Observable<Benefit> {
    return this.api.create(mapBenefitRequest(request)).pipe(map(mapBenefit));
  }

  update(benefitId: number, request: BenefitRequest): Observable<Benefit> {
    return this.api
      .update(benefitId, mapBenefitRequest(request))
      .pipe(map(mapBenefit));
  }

  deactivate(benefitId: number): Observable<void> {
    return this.api.deactivate(benefitId);
  }
}
